const Calendars = {
  /** Calendar link used for scheduling demos */
  ScheduleDemo: 'https://meetings.hubspot.com/chez-gaspercic/bluecargodemo-?embed=true',
};

export default Calendars;
